import { useState, useEffect } from "react";
import "./index.css";

function ProjectsPopup({ onNavigate }) {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    // Show popup after 1 second
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsClosing(false);
    }, 300);
  };

  const handleNavigate = () => {
    if (onNavigate) {
      onNavigate();
    }
  };

  if (!isVisible) return null;

  return (
    <div className={`projects-popup ${isClosing ? "closing" : ""}`}>
      <button className="projects-popup__close" onClick={handleClose}>
        ×
      </button>
      <button className="projects-popup__button" onClick={handleNavigate}>
        Check out my personal projects!
      </button>
    </div>
  );
}

export default ProjectsPopup;
